import React from 'react';
import moment from 'moment';
import i18n from 'i18next';
import { Select, Tag, Breadcrumb, Icon, Checkbox, Tooltip } from 'antd';
import { Button, Form } from 'antd';
import loadingImg from '../login/img/list-loading.png';
import { apis } from '../api/index.js';
import CryptoJS from 'crypto-js';
const { Option } = Select;

//格式化时间
export function formatDate(date, fmt = 'YYYY-MM-DD HH:mm:ss') {
  return date ? moment(date).format(fmt) : '';
}

//格式化get的传参
export function getParams(params) {
  let array = [];
  for (let i in params) {
    if (typeof params[i] === 'number') params[i] = JSON.stringify(params[i]);
    if (params[i] && JSON.stringify(params[i]).length > 0)
      array.push(i + '=' + params[i]);
  }
  return array.join('&');
}

//性别
export function getSex(sexNum) {
  if (sexNum === 'F') return i18n.t('female');
  else if (sexNum === 'M') return i18n.t('male');
  else return sexNum;
}

//格式化时间
export function formatDA(date, strFormat = 'YYYY-MM-DD HH:mm:ss') {
  if (!date) return;
  const dateAsMoment = moment(date);
  return dateAsMoment.format(strFormat);
}

// 计算出图片画在canvas中的四个参数,使其在canvas中自适应大小且居中显示
function calculate(iw, ih, cw, ch) {
  let [px, py] = [0, 0];
  if (iw < cw && ih < ch) {
    px = 0.5 * cw - 0.5 * iw;
    py = 0.5 * ch - 0.5 * ih;
  } else if (ih / iw > ch / cw) {
    let uu = ih;
    ih = ch;
    iw = (iw * ch) / uu;
    px = 0.5 * cw - 0.5 * iw;
  } else {
    let uu = iw;
    iw = cw;
    ih = (ih * iw) / uu;
    py = 0.5 * ch - 0.5 * ih;
  }
  return { px, py, iw, ih };
}

//根据token获取图像
export function getImageWithToken(url, id, len) {
  let xmlHttp = new XMLHttpRequest();
  xmlHttp.open('GET', url, true);
  xmlHttp.responseType = 'blob';
  const token = window.localStorage.getItem('access_token');
  xmlHttp.setRequestHeader('Authorization', 'Bearer ' + token); //该处加上你当前的token
  xmlHttp.onload = function() {
    if (xmlHttp.status === 200) {
      let blob = this.response;
      let img = document.createElement('img');
      const canvas = document.createElement('canvas');
      img.onload = function(e) {
        window.URL.revokeObjectURL(img.src);

        let [width, height] = [200, 200];
        if (len > 2) {
          [width, height] = [170, 170];
        }
        canvas.width = width;
        canvas.height = height;

        let local = calculate(img.width, img.height, width, height);

        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, width, height);
        ctx.drawImage(img, local.px, local.py, local.iw, local.ih);
      };
      img.setAttribute('class', 'image-view');
      img.src = window.URL.createObjectURL(blob);
      const el = document.getElementById(id);
      const children = el.childNodes;
      for (let i = children.length - 1; i >= 0; i--) {
        el.removeChild(children[i]);
      }
      el.appendChild(canvas);
    }
  };
  xmlHttp.send(null);
}

//返回上一页
export function back(props) {
  props.history.go(-1);
}

//切换菜单
export function changeListWidth(_this, collapsed) {
  const width = collapsed ? 'calc(87% - 8px)' : 'calc(94% - 8px)';
  setTimeout(() => {
    _this.setState({ listWidth: width });
  }, 5);
}

//机构下拉列表
export function getInstitutionOptions(institutionData, valueType) {
  if (!institutionData) return;
  const options = institutionData.map((item, index) => {
    if (valueType === 'name') {
      const name = item.institutionName;
      return (
        <Option key={index} value={name} title={name}>
          {name}
        </Option>
      );
    } else {
      const id = item.id;
      const name = item.institutionName;
      return (
        <Option key={index} value={id} title={name}>
          {name}
        </Option>
      );
    }
  });
  return options;
}

//省份下拉列表
export function getProvinceOption(provinceList) {
  if (!provinceList) return;
  return provinceList.map((item, index) => (
    <Option key={index} value={item.id} title={item.areaName}>
      {item.areaName}
    </Option>
  ));
}

//获取质控状态
export function getQCStatus(passed, chestPA) {
  if (chestPA !== 1) return <Tag color="#A6A6A6">{i18n.t('unKnown')}</Tag>;
  else if (passed) return <Tag color="#77c565">{i18n.t('qualified')}</Tag>;
  else return <Tag color="#f50">{i18n.t('unqualified')}</Tag>;
}

// 处理月份
export function doHandleMonth(month) {
  let m = month;
  if (month.toString().length === 1) m = '0' + month;
  return m;
}

//格式化检查部位、体位
export function getBodyPartText(list = []) {
  const part = [];
  list.forEach(item => {
    if (item.bodyPartName) part.push(item.bodyPartName);
  });
  return part.join('/');
}

//格式化开始时间、结束时间
export function formatFromTime(times) {
  let fromTime = times && times[0] ? moment(times[0]).format('YYYY-MM-DD') : '';
  fromTime = fromTime ? fromTime + ' 0:0:0' : '';
  return fromTime;
}

export function formatToTime(times) {
  let toTime = times && times[1] ? moment(times[1]).format('YYYY-MM-DD') : '';
  toTime = toTime ? toTime + ' 23:59:59' : '';
  return toTime;
}

//急诊类型下拉
export function emergencyOption() {
  const list = ['普通', '白天急诊', '夜间急诊'];
  const listOption = list.map((item, index) => (
    <Option key={index} value={index} title={item}>
      {item}
    </Option>
  ));
  return listOption;
}

//获取急诊类型名称
export function emergencyName(value) {
  const list = ['普通', '白天急诊', '夜间急诊'];
  return list[value];
}

//获取患者来源下拉
export function patientSourceOption() {
  const list = ['门诊', '住院', '体检'];
  const listOption = list.map((item, index) => (
    <Option key={index} value={index} title={item}>
      {item}
    </Option>
  ));
  return listOption;
}

//获取患者来源名称
export function patientSourceName(value) {
  const list = ['门诊', '住院', '体检'];
  return list[value];
}

//获取状态名称
export function getStateName(state, flag) {
  const list = [
    { value: 1, label: '待申请', color: '#ff2c2c' },
    { value: 10, label: '待报告', color: '#ED5A5A' },
    { value: 11, label: '报告中', color: '#6A97F5' },
    { value: 12, label: '已拒绝', color: '#B47272' },
    { value: 20, label: '待一审', color: '#F4A237' },
    { value: 21, label: '一审中', color: '#5EC8DD' },
    { value: 25, label: '待二审', color: '#F4A237' },
    { value: 26, label: '二审中', color: '#5EC8DD' },
    { value: 22, label: '已审核', color: '#78C493' },
    { value: 30, label: '已打印', color: '#78C493' },
    { value: 201, label: '已打印', color: '#78C493' }, //待审核已打印（夜间急诊）
    { value: 40, label: '纠错中', color: '#559ACD' },
    { value: 42, label: '已审核', color: '#78C493' }, //已纠错
    { value: 46, label: '已打印', color: '#78C493' }, //纠错后已打印
    { value: 251, label: '已打印', color: '#78C493' },
  ];
  let html = '';
  if (flag === 1) {
    html = <Tag color="#A4A6A7">暂不申请</Tag>;
  } else {
    list.forEach(item => {
      if (item.value === state)
        html = <Tag color={item.color}>{item.label}</Tag>;
    });
  }
  return html;
}

//AI筛选条件
export function getAIFilterList(productionId) {
  let list = [];
  switch (productionId) {
    case '11':
      list = [
        { name: '正常', value: '1' },
        { name: '活动性肺结核', value: '2' },
        { name: '整体异常', value: '3' },
      ];
      break;
    case '9':
      list = [
        { name: '正常', value: '1' },
        { name: '活动性肺结核', value: '2' },
        { name: '肺炎', value: '6' },
        { name: '结节肿块', value: '4' },
        { name: '胸膜胸腔', value: '5' },
        { name: '整体异常', value: '3' },
      ];
      break;
    case '6':
      list = [
        { name: '正常', value: '1' },
        { name: '病毒性肺炎', value: '2' },
        { name: '整体异常', value: '3' },
      ];
      break;
    case '1001':
      list = [
        { name: '未知', value: '0' },
        { name: '正常', value: '1' },
        { name: '异常', value: '2' },
      ];
      break;
    default:
      break;
  }
  return list.map((item, index) => (
    <Option value={item.value} key={index}>
      {item.name}
    </Option>
  ));
}
// 计算两个时间差 dateBegin 开始时间
export function timeFn(dateEnd) {
  dateEnd = new Date(dateEnd).getTime() + 600000;
  let dateBegin = new Date().getTime();
  //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
  let dateDiff = dateEnd - dateBegin; //时间差的毫秒数
  let dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
  let leave1 = dateDiff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
  let hours = Math.floor(leave1 / (3600 * 1000)); //计算出小时数
  //计算相差分钟数
  let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
  let minutes = Math.floor(leave2 / (60 * 1000)); //计算相差分钟数
  let timeFn = '';
  if (dateDiff < 0) {
    timeFn += '超出';
    dayDiff += 1;
    dayDiff = Math.abs(dayDiff);
    hours += 1;
    hours = Math.abs(hours);
    minutes = Math.abs(minutes);
  }
  if (dayDiff) timeFn += dayDiff + '天' + hours + '时' + minutes + '分';
  else if (hours) timeFn += hours + '时' + minutes + '分';
  else if (minutes) timeFn += minutes + '分';

  return timeFn;
}

//生成随机密码
export function passwordBuilder(len) {
  let pasArr = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j'];
  pasArr = pasArr.concat(['k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't']);
  pasArr = pasArr.concat(['u', 'v', 'w', 'x', 'y', 'z']);
  pasArr = pasArr.concat(['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J']);
  pasArr = pasArr.concat(['K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T']);
  pasArr = pasArr.concat(['U', 'V', 'W', 'X', 'Y', 'Z']);
  pasArr = pasArr.concat(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']);
  let password = '';
  let pasArrLen = pasArr.length;
  for (let i = 0; i < len; i++) {
    let x = Math.floor(Math.random() * pasArrLen);
    password += pasArr[x];
  }
  return password;
}

export function getDay(day, type) {
  const today = new Date();
  const day_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
  today.setTime(day_milliseconds); //注意，这行是关键代码
  const tYear = today.getFullYear();
  let tMonth = today.getMonth();
  let tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  if (type === 'YMD') return tMonth + '/' + tDate;
  else return tYear + '-' + tMonth + '-' + tDate;
}

//计算从from开始后range段时间后的日期
export function getEndDay(from, range) {
  let day = new Date(from);
  let day_milliseconds = day.getTime() + 1000 * 60 * 60 * 24 * range;
  day.setTime(day_milliseconds);
  let tYear = day.getFullYear();
  let tMonth = day.getMonth();
  let tDate = day.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  return tYear + '-' + tMonth + '-' + tDate;
}

export function setScrollTop() {
  //滚动条重置到顶部
  const dom = document.querySelector('.ant-table-body');
  dom.scrollTop = 0;
}

export function calcTableHeight(height) {
  const form = document.querySelector('.ant-advanced-search-form');
  if (!form) return;
  let newHeight = document.body.clientHeight - height - form.clientHeight;
  document.querySelector('.ant-table-body').style.maxHeight = newHeight + 'px';
  return newHeight;
}

export function showMoreSearch(height = 80) {
  const search = document.querySelector('.searchBoxContent');
  if (!search) return false;
  let show = search.clientHeight > height;
  return show;
}

//当前时间是否在某一时间段内
export function isDuringDate(beginDateStr, endDateStr) {
  const curDate = new Date();
  const beginDate = new Date(beginDateStr);
  const endDate = new Date(endDateStr);
  if (curDate >= beginDate && curDate <= endDate) return true;
  return false;
}

//是否包含某个元素
export function isIncluded(roleArray, roleInfo) {
  let flag = false;
  roleArray.forEach(item => {
    if (roleInfo.indexOf(item) >= 0) flag = true;
  });
  return flag;
}

export function getProjectOption(list) {
  return list.map((item, index) => (
    <Option key={index} value={item.id}>
      {item.name}
    </Option>
  ));
}

export function fastDateOption() {
  const list = [
    { value: 0, name: '今天' },
    { value: 2, name: '近3天' },
    { value: 6, name: '近7天' },
    { value: 29, name: '近30天' },
  ];
  return list.map((item, index) => (
    <Option key={index} value={item.value}>
      {item.name}
    </Option>
  ));
}

export function reviewStateOption() {
  const list = [
    { value: '10', name: '待审核' },
    { value: '20', name: '审核中' },
    { value: '30', name: '已审核' },
  ];
  return list.map((item, index) => (
    <Option value={item.value} key={index}>
      {item.name}
    </Option>
  ));
}

//面包屑导航
export function breadItem(list) {
  return list.map((item, index) => {
    if (index === 0)
      return (
        <Breadcrumb.Item key={index}>
          <Icon type="environment" theme="filled" />
          <span>{item}</span>
        </Breadcrumb.Item>
      );
    else return <Breadcrumb.Item key={index}>{item}</Breadcrumb.Item>;
  });
}

//面包屑返回
export function breadBack(_this) {
  return (
    <div
      className="back"
      onClick={() => {
        _this.setBackEvent();
        back(_this.props);
      }}
    >
      &lt;返回
    </div>
  );
}

//自动刷新
export function autoFresh(_this) {
  return (
    <div className="switch-button">
      <Checkbox
        checked={_this.state.autoRefreshStatus}
        onChange={e => {
          switchOnChange(e, _this);
          _this.setFreshEvent(e);
        }}
      >
        自动刷新
      </Checkbox>
    </div>
  );
}

//切换自动刷新按钮
export function switchOnChange(e, _this) {
  const data = window.store.getState().api.current.searchInfo || {};
  data.autoRefreshStatus = e.target.checked;
  _this.props.setCurrentSearchInfoData(data);
  _this.reFreshList(e.target.checked);
}

//保存搜索数据
export function setSearchInfo(state, name, _this) {
  const searchInfo = window.store.getState().api.current.searchInfo;
  searchInfo[name] = Object.assign({}, searchInfo[name], state);
  _this.props.setCurrentSearchInfoData(searchInfo);
}

//table标题说明
export function toolTipTitle(title, position) {
  return (
    <Tooltip
      className="table-tooltip"
      placement={position}
      arrowPointAtCenter={true}
      autoAdjustOverflow={true}
      title={title}
    >
      <Icon className="title-question" type="question-circle" theme="filled" />
    </Tooltip>
  );
}

export function loadingOptionsHtml(searchLoading) {
  return {
    indicator: (
      <div className="list-loading">
        <img src={loadingImg} alt="" />
        <div className="trajectory">
          <Icon type="search" className="list-search-icon" />
        </div>
      </div>
    ),
    tip: '数据加载中，请稍后… …',
    spinning: searchLoading,
  };
}

export function setCountTime(time) {
  let date = new Date(time);
  let min = date.getMinutes();
  date.setMinutes(min + 60);
  //年
  let y = date.getFullYear();
  //月
  let m = date.getMonth();
  m = m + 1 < 10 ? '0' + (m + 1) : m + 1;
  //日
  let d = date.getDate();
  d = d < 10 ? '0' + d : d;
  //时
  let h = date.getHours();
  h = h < 10 ? '0' + h : h;
  //分
  let f = date.getMinutes();
  f = f < 10 ? '0' + f : f;
  //秒
  let s = date.getSeconds();
  s = s < 10 ? '0' + s : s;

  return y + '-' + m + '-' + d + ' ' + h + ':' + f + ':' + s;
}

export function timeCalc(value) {
  let fromTime = getDay(-value) + ' 0:0:0';
  let toTime = getDay(0) + ' 23:59:59';
  return { fromTime, toTime };
}

export function loadingOptions(searchLoading) {
  return {
    indicator: (
      <div className="list-loading">
        <img src={loadingImg} alt="" />
        <div className="trajectory">
          <Icon type="search" className="list-search-icon" />
        </div>
      </div>
    ),
    tip: '数据加载中，请稍后… …',
    spinning: searchLoading,
  };
}
export function getBrowserInfo() {
  const Sys = {};
  const ua = navigator.userAgent.toLowerCase();
  const re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/;
  const m = ua.match(re);
  Sys.browser = m[1].replace(/version/, "'safari");
  Sys.ver = m[2];
  return Sys;
}
export function eventListener(post, isCT) {
  const { productionId, pageId, moduleId, elementId, respCode, respMsg } = post;
  const browser = getBrowserInfo();
  const userInfo = window.store.getState().api.user.info;
  const userId = userInfo.id;
  const userName = userInfo.nickName;
  const instId = userInfo.institutionId;
  let terminal = '2';
  if (typeof _$x !== 'undefined') terminal = '1';
  // const cityJson = JSON.parse(localStorage.getItem('cityJson'));
  const eventTime = formatDA(new Date());

  const prevPage = window.store.getState().api.current.prevPage || '';
  let pageSource = '';
  if (prevPage.indexOf('auxiliaryDiagnosis') > -1) pageSource = '10042';
  else if (prevPage.indexOf('intelligentAnalysis') > -1) pageSource = '10044';
  else if (prevPage.indexOf('viewer/study') > -1) pageSource = '10043';
  else if (prevPage.indexOf('login') > -1) pageSource = '10046';

  const data = {
    productionId,
    pageId,
    moduleId,
    elementId,
    userId,
    userName,
    instId,
    chromeVersion: browser.browser + browser.ver,
    sr: window.screen.width + '*' + window.screen.height,
    terminal,
    respCode: respCode || 0,
    respMsg: respMsg || '成功',
    // terminalIp: cityJson.ipAddress,
    eventTime,
    pageSource,
    prms: post.prms,
  };
  let [eventKey] = [''];
  if (isCT) eventKey = 'ctEventList';
  else eventKey = 'eventList';

  let eventData = localStorage.getItem(eventKey) || '[]';
  let eventList = JSON.parse(eventData);
  eventList.push(data);

  if (eventList.length >= 2) {
    localStorage.setItem(eventKey, '[]');
    if (isCT) apis.ctSaveEvent(eventList);
    else apis.saveEvent(eventList);
  } else {
    localStorage.setItem(eventKey, JSON.stringify(eventList));
  }
}

export function buttonS(_this) {
  return (
    <Form.Item>
      <Button
        type="primary"
        htmlType="submit"
        className="btn-search"
        disabled={_this.state.searchLoading}
      >
        {_this.state.loadingIconShow ? (
          <Icon type="sync" spin />
        ) : (
          <Icon type="search" />
        )}
        搜索
      </Button>
      <Button
        style={{ marginLeft: 8 }}
        icon="redo"
        className="btn-reset"
        disabled={_this.state.searchLoading}
        onClick={_this.handleReset}
      >
        重置
      </Button>
    </Form.Item>
  );
}

export function checkProv(value) {
  let pattern = /^[1-9][0-9]/;
  let provs = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江 ',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北 ',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏 ',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
  };
  if (pattern.test(value) && provs[value]) return true;

  return false;
}
//出生日期码校验
export function checkDate(val) {
  //年份是18、19、20开头
  const pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
  if (pattern.test(val)) {
    const year = val.substring(0, 4);
    const month = val.substring(4, 6);
    const date = val.substring(6, 8);
    const date2 = new Date(year + '-' + month + '-' + date);
    if (date2 && date2.getMonth() === parseInt(month) - 1) {
      return true;
    }
  }
  return false;
}
//AES加密
export const aesMinEncrypt = word => {
  const [key, iv] = ['ABCDEFGHIJKL_key', 'ABCDEFGHIJKLM_iv'];
  const _word = CryptoJS.enc.Utf8.parse(word),
    _key = CryptoJS.enc.Utf8.parse(key),
    _iv = CryptoJS.enc.Utf8.parse(iv);
  let encrypted = CryptoJS.AES.encrypt(_word, _key, {
    iv: _iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();

  return encrypted;
};

export const checkPassword = value => {
  // 0： 表示第一个级别 1：表示第二个级别 2：表示第三个级别
  // 3： 表示第四个级别 4：表示第五个级别
  let modes = 0;

  //最初级别
  if (value.length < 6) return modes;

  //如果用户输入的密码 包含了数字
  if (/\d/.test(value)) modes++;

  //如果用户输入的密码 包含了小写的a到z
  if (/[a-z]/.test(value)) modes++;

  //如果用户输入的密码 包含了大写的A到Z
  if (/[A-Z]/.test(value)) modes++;
  //如果是非数字 字母 下划线
  if (/\W/.test(value)) modes++;

  return modes;
};

//格式化开始时间、结束时间
export function formatRange(times) {
  let fromTime = times && times[0] ? moment(times[0]).format('YYYY-MM-DD') : '';
  fromTime = fromTime ? fromTime + ' 0:0:0' : '';
  let toTime = times && times[1] ? moment(times[1]).format('YYYY-MM-DD') : '';
  toTime = toTime ? toTime + ' 23:59:59' : '';

  return [fromTime, toTime];
}
